import { questionType, questionTitle } from '@edulastic/constants'
import { EXACT_MATCH } from '@edulastic/constants/const/evaluationType'
import uuid from 'uuid/v4'

export const getDefaultDataByQuestionType = (type) => {
  const uuids = [uuid(), uuid(), uuid(), uuid()]

  const defaultDataByQuestionType = {
    MCQ_TF: {
      title: questionTitle.MCQ_TRUE_OR_FALSE,
      type: questionType.MULTIPLE_CHOICE,
      stimulus: '',
      uiStyle: {
        type: 'standard',
      },
      options: [
        { value: uuids[0], label: 'True' },
        { value: uuids[1], label: 'False' },
      ],
      validation: {
        scoringType: EXACT_MATCH,
        validResponse: {
          score: 1,
          value: [uuids[0]],
        },
        altResponses: [],
      },
      multipleResponses: false,
      hints: [{ value: uuids[0], label: '' }],
    },
    MCQ_MS: {
      title: questionTitle.MCQ_MULTIPLE_RESPONSE,
      type: questionType.MULTIPLE_CHOICE,
      stimulus: '',
      uiStyle: {
        type: 'standard',
      },
      options: [
        { value: uuids[0], label: '' },
        { value: uuids[1], label: '' },
        { value: uuids[2], label: '' },
        { value: uuids[3], label: '' },
      ],
      validation: {
        scoringType: EXACT_MATCH,
        validResponse: {
          score: 1,
          value: [uuids[1]],
        },
        altResponses: [],
      },
      multipleResponses: true,
      hints: [{ value: uuids[0], label: '' }],
    },
    MCQ_ST: {
      title: questionTitle.MCQ_STANDARD,
      type: questionType.MULTIPLE_CHOICE,
      stimulus: '',
      uiStyle: {
        type: 'standard',
      },
      options: [
        { value: uuids[0], label: '' },
        { value: uuids[1], label: '' },
        { value: uuids[2], label: '' },
        { value: uuids[3], label: '' },
      ],
      validation: {
        scoringType: EXACT_MATCH,
        validResponse: {
          score: 1,
          value: [uuids[0]],
        },
        altResponses: [],
      },
      multipleResponses: false,
      hints: [{ value: uuids[0], label: '' }],
    },
    CLOZE_TEXT: {
      title: questionTitle.CLOZE_TEXT,
      type: questionType.CLOZE_TEXT,
      stimulus: `<p>Fill blank boxes with the right answer.</p><p>Sample question text with <textinput responseindex="0" id="${uuids[0]}" contenteditable="false"></textinput>&nbsp;and<textinput responseindex="1" contenteditable="false" id="${uuids[1]}"></textinput>&nbsp;</p>`,
      uiStyle: {
        fontsize: 'normal',
        heightpx: 32,
        placeholder: '',
        responsecontainerindividuals: [],
        responsecontainerposition: 'bottom',
        stemNumeration: '',
        widthpx: 140,
      },
      responseIds: [
        { index: 0, id: uuids[0] },
        { index: 1, id: uuids[1] },
      ],
      validation: {
        scoringType: EXACT_MATCH,
        validResponse: {
          score: 1,
          value: [
            { id: uuids[0], index: 0, value: 'Answer 1' },
            { id: uuids[1], index: 1, value: 'Answer 2' },
          ],
        },
        mixAndMatch: true,
        altResponses: [],
      },
      hints: [{ value: uuids[0], label: '' }],
    },
    SHORT_TEXT: {
      title: questionTitle.SHORT_TEXT,
      type: questionType.SHORT_TEXT,
      stimulus: '',
      validation: {
        scoringType: EXACT_MATCH,
        validResponse: {
          score: 1,
          matchingRule: EXACT_MATCH,
          value: '',
        },
        altResponses: [],
      },
      hints: [{ value: uuids[0], label: '' }],
    },
  }

  return defaultDataByQuestionType[type]
}
